import MockAdapter from "axios-mock-adapter";
import {Engine} from "@milestoneslabs/milestones-core-js";

export class MockAdapterSingleton extends MockAdapter {
    constructor() {
        super(Engine.xhrLib, {delayResponse: 2000});
    }
}
let mockAdapterSingleton = null;
if (window.env.USE_AXIOS_MOCK_ADAPTER) {
    mockAdapterSingleton = new MockAdapterSingleton();
}

export {mockAdapterSingleton};
